import { useSearchableMenu } from 'shared/domains/common-ui';
import { FormSubmitButton } from './FormSubmitButton';
export function SubmitButtonForSearchableLists() {
    const { hasResult } = useSearchableMenu();
    return <FormSubmitButton disabled={!hasResult}/>;
}
